var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":_vm.docURL,"height":_vm.height,"width":_vm.width}})])
}
var staticRenderFns = []

export { render, staticRenderFns }